import React, { useState } from "react";

import Cart from "../containers/Cart";
import { CouponContext } from "../contexts/coupon";
import ModalCoupon from "../components/ModalCoupon";
import { Helmet } from "react-helmet";
import { CreditContext } from "../contexts/credit";
import ModalAddCredit from "../components/ModalAddCredit";

function BasketPage() {
  let [isCouponModalOpen, setCouponModalOpen] = useState(false);
  let [isCreditModalOpen, setCreditModalOpen] = useState(false);
  let [prefilledValue, setPrefilledValue] = useState(null);

  let [meta, setMeta] = useState({});

  return (
    <CouponContext.Provider
      value={{
        isCouponModalOpen,
        setCouponModalOpen,
      }}
    >
      <CreditContext.Provider
        value={{
          isCreditModalOpen,
          setCreditModalOpen: (value, meta) => {
            setCreditModalOpen(value);
            setMeta(meta);
          },
          setPrefilledValue,
          prefilledValue,
          meta,
        }}
      >
        <Helmet>
          <title>تکمیل سفارش | دیجی واش</title>
        </Helmet>
        <Cart />
        <ModalCoupon />
        <ModalAddCredit />
      </CreditContext.Provider>
    </CouponContext.Provider>
  );
}

export default BasketPage;
